const AuthReducerWL = ['auth.persistentUserId'];
const CartReducerWL = ['CartReducer.deleteModalOpen', 'CartReducer.exercisesInCart', 'CartReducer.homeworkTitle', 'CartReducer.homeworkDescription'];
const ExerciseReducerWL = ['Exercise.errorMsg', 'Exercise.searchIdList', 'Exercise.searchTerm'];

export const PersistenceWhiteList = [...AuthReducerWL, ...CartReducerWL, ...ExerciseReducerWL];
